




























import { defineComponent, onMounted, ref, useFetch } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import { getProductTopicBgColor } from '~/utils/solepro/products';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';

export default defineComponent({
    components: {
        HTMLContent
    },
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    setup(props) {
        const bgColor = ref('#F7F7F7');
        useFetch(async () => {
            const categoriesStore = useCategoryStore();
            await categoriesStore.load()
            const categories = categoriesStore.rawCategories?.items[0].children
            bgColor.value = getProductTopicBgColor(categories, props.product, '#F7F7F7')
        })

        onMounted(() => {
            setTimeout(() => {
                const points = Array.from(document.querySelectorAll('.area_funzionalita .pb_column-group .pagebuilder-column:first-child'))
                if (points.length < 1) return;
                points.forEach(el => el.classList.add('basis-0'))
            }, 0)
        })

        return {
            bgColor,
            isAreaFunzionalitaColumns : !!props.product.area_funzionalita && props.product.area_funzionalita.includes('punti-forza-columns') ,
            isAreaFunzionalitaFull: !!props.product.area_funzionalita && props.product.area_funzionalita.includes('punti-forza-grid') 
        }
    }
})
